import styled from "styled-components";
import { COLORS } from "styles/colors";
import { FLEX } from "styles/flex";
import { calcRem } from "styles/theme";
import * as mediaQuery from "components/MediaQuery";
export const Row = styled.div`
  ${FLEX.FlexStartCenter};
  gap: 15px;
`;
export const NameLabel = styled(Row)`
  /* gap: 7px; */
  cursor: pointer;
`;

export const ButtonWrapper = styled(Row)<{ disabled?: boolean }>`
  ${({ disabled }) =>
    disabled &&
    `
    opacity: 0.25;
  `}
`;

/**
 * View Modal Styled
 */
export const ViewInner = styled.section`
  width: 100%;
  text-align: left;
  color: #828b9b;
  line-height: 1.5rem;
`;

export const ViewSubWrapper = styled.ul`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

export const ViewSubTitle = styled.li`
  color: ${({ theme }) => theme.COLORS.TEXT};
  font-size: ${calcRem(14)};
  display: grid;
  grid-template-columns: 70px auto;
  &.message {
    border: 1px solid ${({ theme }) => theme.COLORS.LIGHTGRAYBORDER};
    padding: 10px;
    border-radius: 6px;
    grid-template-columns: 1fr;
  }
  .to {
    ${FLEX.FlexStartCenter};
    flex-wrap: wrap;
    gap: 5px;
  }
  &.subject {
    font-size: ${calcRem(16)};
    font-weight: 500;
    color: ${({ theme }) => theme.COLORS.WHITE};
  }

  strong {
    padding-right: 10px;
  }

  .message {
    padding-bottom: 20px;
  }
`;

export const EmailPresenterWrapper = styled.div`
  .title-left {
    ${mediaQuery.isDefault} {
      flex: auto;
    }
  }
`;
